<div [class]="categoryCarouselCSS()">
  <ng-container #categoryCarousel></ng-container>
</div>
